import { createFileRoute } from "@tanstack/react-router";

import { MyChats } from "@/features/my/chats";
import { chatsSearchSchema } from "@/features/my/chats/_configs/chats-search-schema";

export const Route = createFileRoute("/(member)/(protected)/my/chats")({
  component: MyChats,
  validateSearch: chatsSearchSchema,
});
